import React from 'react'

const HeaderInfo = ({ title, description }) => {
    return (
        <div className={`dashboard-top-wrapper`}>
            <div className="dashboard-top-left">
                <div className='dashboard-top'>
                    <h2 className="dashboard-top-text">{title}</h2>
                    <p className="dashboard-top-subtext">
                        {description}
                    </p>
                </div>
            </div>
        </div>
    )
}

export default HeaderInfo
